import styled from 'styled-components';

export const Wrapper = styled.div`
  // margin-top: 20px;
  // background-color: ${({ theme }) => theme.colors.white};
  // padding: 30px 20px;

  margin: 18px 0px 200px;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.white};
  max-width: 1000px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    background-color: ${({ theme }) => theme.colors.lighterBackground};
  }
  & .contents {
    margin-left: 30px;
  }
  .header {
    display: flex;
    flex-direction: column;
    gap: 30px;

    & .heading-inner {
      display: flex;
      flex-direction: column;
      gap: 20px;

      & .heading-detail {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
    }
  }

  .form {
    display: flex;
    flex-direction: column;
    gap: 30px;

    & .form-inputs {
      display: grid;
      grid-template-columns: 1fr;
      gap: 20px;

      & .input-text {
        display: flex;
        flex-direction: column;
        gap: 8px;

        & .input {
          width: 100%;
          border: 1px solid ${({ theme }) => theme.colors.disableButtonText};
        }
      }
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        grid-template-columns: 1fr 1fr;
      }
    }
  }

  .actions {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 20px;

    & .assign-heading {
      display: flex;
      align-items: center;

      & p {
        width: 300px;
        margin: 0 0 0 15px;

        @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
          margin: 0 -30px 0 15px;
        }
      }
    }

    & .btn {
      /* display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px; */
      & button {
        width: 100%;
        background-color: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.darkText};
        padding: 0 4px;

        @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
          padding: 0 14px;
        }
      }
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        gap: 37px;
      }
    }

    & .select {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      width: 60%;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      width: 50%;
    }
  }
`;
